import { render, staticRenderFns } from "./CustomNavBar.vue?vue&type=template&id=635be277&scoped=true"
import script from "./CustomNavBar.vue?vue&type=script&lang=js"
export * from "./CustomNavBar.vue?vue&type=script&lang=js"
import style0 from "./CustomNavBar.vue?vue&type=style&index=0&id=635be277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635be277",
  null
  
)

export default component.exports